import { useState } from 'react';
import styles from './Integrations.module.css';

/** Local examples only: never call the scheduling API from an onboarding card. */
export function CalendarPreview() {
  const [title, setTitle] = useState('Project follow-up');
  const [scheduled, setScheduled] = useState(false);
  return <div className={styles.preview} aria-label="Calendar preview">
    <h3>Your meetings, here on Home</h3>
    <p>See upcoming meetings with your CRM contacts. Ask Echo to arrange a meeting, then review the details before scheduling.</p>
    <article className={styles.card}>
      <span className={styles.exampleLabel}>Example meeting draft</span>
      {scheduled ? <div role="status">
        <h3>Example scheduled</h3>
        <p>Just a preview. No meeting was created or invitation sent.</p>
        <button type="button" className={styles.previewButton} onClick={() => setScheduled(false)}>Try again</button>
      </div> : <>
        <div className={styles.fields}>
          <label>Meeting title<input value={title} onChange={e => setTitle(e.target.value)} /></label>
        </div>
        <p>Friday · 2:00–2:30 PM<br />With Alex Morgan · alex@example.com</p>
        <button type="button" className={styles.previewButton} disabled={!title.trim()} onClick={() => setScheduled(true)}>Try scheduling</button>
        <p className={styles.meta}>Example only. No invitation will be sent.</p>
      </>}
    </article>
    <p>Connecting shows meetings from your primary calendar with CRM contacts. Scheduling always needs your approval.</p>
  </div>;
}
